<template>
    <steps-option @updateNavigation="updateNavigation" />
</template>

<script>
    import StepsOption from './StepsOption.vue';

    export default {
        components: {
            StepsOption,
        },

        methods: {
            updateNavigation(navRules) {
                this.$emit('updateNavigation', navRules);
            },
        },
    };
</script>
